export default __webpack_public_path__ + "static/media/housing.88cb9636.PNG";